import { Component } from '@angular/core';

@Component({
  selector: 'app-google-icon',
  standalone: true,
  host: { class: 'ui-icon' },
  templateUrl: './google-icon.component.html',
  styleUrl: '../icon-base.scss'
})
export class GoogleIconComponent {}
